export enum EnhancementAddOn {
  optimize = 'optimize',
  photo = 'photo',
  video = 'video',
}
